export function isDesktop() {
  const x = window.matchMedia("(min-width: 992px)")
  return x.matches;    
}